import { faListCheck } from '@fortawesome/pro-solid-svg-icons'
import clsx from 'clsx'
import type { TaskEvent } from '~/domains/actions/types'
import {
  historyItemContent,
  historyItemMeta,
  historyItemStatus,
  historyItemStatusCancelled,
  historyItemStatusCompleted,
  historyItemStatusNotCompleted
} from '../ApplicantHistory.css'
import { BaseHistoryCard } from './BaseHistoryCard'

const getTaskMeta = (event: TaskEvent) => {
  if (event.isCancelled) {
    return (
      <span className={clsx(historyItemStatus, historyItemStatusCancelled)}>
        Annulée
      </span>
    )
  }
  if (event.isCompleted) {
    return (
      <span className={clsx(historyItemStatus, historyItemStatusCompleted)}>
        Faite
      </span>
    )
  }
  if (event.isCompleted === false) {
    return (
      <span className={clsx(historyItemStatus, historyItemStatusNotCompleted)}>
        Non aboutie
      </span>
    )
  }
  return null
}

export const TaskHistoryCard = ({ event }: { event: TaskEvent }) => {
  const meta = getTaskMeta(event)

  return (
    <BaseHistoryCard
      event={event}
      icon={faListCheck}
      title={
        <>
          {event.actionType
            ? `${event.actionType}${event.subject ? ` : ${event.subject}` : ''}`
            : (event.subject ?? 'Tâche')}
          {meta && <div className={historyItemMeta}>{meta}</div>}
        </>
      }
    >
      {event.notes && <div className={historyItemContent}>{event.notes}</div>}
    </BaseHistoryCard>
  )
}
